import CreateApprovalClaimModalHook from './CreateApprovalClaimModal.hook'
import AutoCompleteSearchUser from '../AutoCompleteSearchUser/AutoCompleteSearchUser'
import { Form } from 'antd'
import {
  BodyStyled,
  CloseOutlinedIcon,
  FormItem,
  FormSelectWrapper,
  Label,
  LabelWrapper,
  Modal,
  RequestWrapper,
  SearchWrapper,
  SelectWrapper,
  StyledUser,
  StyledUserName,
  AntSelectStyled,
} from './styles'

export default function CreateApprovalClaimModal() {
  const {
    createClaimApprovalModal,
    onCancelModal,
    queryListHealthClaimUserApprove,
    form,
    userValue,
    onFinish,
    onHandleSubmit,
    isPendingApproval,
    watchApprovalConditionId,
    isSubmitDisabled,
    updateSubmitDisabledState,
  } = CreateApprovalClaimModalHook()

  return (
    <Modal
      title="เพิ่มผู้อนุมัติ"
      open={createClaimApprovalModal.open}
      closable={false}
      cancelText="ยกเลิก"
      okText="เพิ่ม"
      confirmLoading={isPendingApproval}
      onOk={onHandleSubmit}
      onCancel={() => onCancelModal()}
      width={720}
      data-testid="add-create-approval-modal"
      centered
      loading={isPendingApproval}
      okButtonProps={{ disabled: isSubmitDisabled, loading: isPendingApproval }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        validateTrigger="onChange"
        onValuesChange={updateSubmitDisabledState}
      >
        <SearchWrapper>
          <AutoCompleteSearchUser
            userValue={userValue}
            onChangeUser={(e) => {
              form.setFieldsValue({
                userValue: Array.isArray(e) ? e : e ? [e] : [],
              })
            }}
            data-testid="add-assign-member-search-input"
            onClear={() => {
              form.setFieldsValue({ userValue: undefined, approvalConditionId: undefined })
              updateSubmitDisabledState()
            }}
          />
          {/* Hidden FormItem to allow validation of the selected user value */}
          <FormItem
            name="userValue"
            style={{ display: 'none' }}
            rules={[{ required: true, message: 'กรุณาเลือกผู้อนุมัติ' }]}
          >
            <input />
          </FormItem>
        </SearchWrapper>
        {userValue && userValue?.length > 0 ? (
          <BodyStyled>
            <StyledUser>
              <StyledUserName>{userValue?.[0]?.label || '-'}</StyledUserName>
            </StyledUser>
            <SelectWrapper>
              <LabelWrapper>
                <Label>ระดับอนุมัติ</Label>
                <RequestWrapper>*</RequestWrapper>
              </LabelWrapper>
              <FormSelectWrapper>
                <FormItem
                  name="approvalConditionId"
                  rules={[{ required: true, message: 'กรุณาเลือกระดับอนุมัติ' }]}
                >
                  <AntSelectStyled
                    options={
                      queryListHealthClaimUserApprove.data?.map((item: any) => ({
                        label: `${item.name}${
                          item.amountDisplay ? ` (${item.amountDisplay})` : ''
                        }`,
                        value: item.id,
                      })) ?? []
                    }
                    notFoundContent={
                      queryListHealthClaimUserApprove.isLoading ? 'กำลังโหลด...' : 'ไม่พบข้อมูล'
                    }
                    data-testid="select-cate-input"
                    placeholder="เลือก"
                  />
                </FormItem>
                {watchApprovalConditionId ? (
                  <CloseOutlinedIcon
                    onClick={() => {
                      // clear the select value
                      form.setFieldsValue({ approvalConditionId: undefined })

                      // re-run validation and update submit disabled state
                      updateSubmitDisabledState()
                    }}
                  />
                ) : null}
              </FormSelectWrapper>
            </SelectWrapper>
          </BodyStyled>
        ) : null}
      </Form>
    </Modal>
  )
}
